<div class="row">
    <div class="col col-md-8">

        <div class="row">
            <!-- <div class="col-xl-4 col-lg-4 col-md-4 col-sm-4 mb-1 select-container">
                <label>Mode de tarification :
                    <span class="required_champs">*</span>
                </label>
                <ng-select [clearable]="false" (change)="check_if_is_famille()"
                    [(ngModel)]="itemToSave.mode_tarification_id" placeholder="Choisissez "
                    name="mode_tarification_id" id="mode_tarification_id" [multiple]="false"
                    [closeOnSelect]="true" >
                    <ng-option *ngFor="let item of itemsModeTarification" [value]="item.id">{{
                        item?.libelle }}
                    </ng-option>
                </ng-select>
            </div> -->
            <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 mb-1"
                style="padding-left: 5px; padding-right: 5px">
                <label>Nombre pers. par famille
                </label>
                <br>
                <input disabled class="form-control custom-input"
                    [(ngModel)]="itemToSave.nombre_personnes_famille"
                    name="nombre_personnes_famille" autocomplete="off" type="text"
                    mask="separator" />
            </div>
            <div class="col col-md-12">
                <div class="table-responsive">
                    <table class="table table-condensed table-hover">
                        <thead>
                            
                            <tr class="custom-table-head">
                                <!-- <th style="width: 9%;">
                                   
                                </th> -->
                                <th> <a style="cursor: pointer;margin-top: 5px;" (click)="refreshListConfig()"
                                        
                                    title="Actualiser">
                                    <i class="fa fa-redo-alt"></i></a>
                                    Statut</th>
                                <th>Plafond</th>
                                <th>Age min</th>
                                <th>Age max</th>
                                <th>Nombre autorisé</th>
                                <th>Nombre suppl. autorisé</th>
                                <th>Surprime</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr style="cursor: pointer;"
                                *ngFor="let item of itemsStatutInitialized; let indice = index">
                                <td style="font-weight: 700;">{{item.libelle}}</td>
                                
                                <td>
                                    <input (input)="onInputChange($event)" class="form-control custom-input"
                                        [(ngModel)]="item.plafond" autocomplete="off"
                                        type="text" mask="separator"
                                        [ngModelOptions]="{standalone: true}" />
                                </td>
                                <td>
                                    <input class="form-control custom-input"
                                        [(ngModel)]="item.age_min" autocomplete="off"
                                        type="text" mask="separator"
                                        [ngModelOptions]="{standalone: true}" />
                                </td>
        
                                <td><input (input)="onInputChange($event)" class="form-control custom-input"
                                        [(ngModel)]="item.age_max" autocomplete="off"
                                        type="text" mask="separator"
                                        [ngModelOptions]="{standalone: true}" />
                                </td>
                                <td><input [disabled]="item.codification =='A'"
                                    (input)="onInputChange($event)"
                                        class="form-control custom-input"
                                        [(ngModel)]="item.nombre_autorise" autocomplete="off"
                                        type="text" mask="separator"
                                        [ngModelOptions]="{standalone: true}" /></td>
        
                                <td><input (input)="onInputChange($event)" [disabled]="item.codification =='A'"
                                        [class.isNotConsidered]="item.nombre_autorise == 0"
                                        class="form-control custom-input"
                                        [(ngModel)]="item.nombre_supplementaire_autorise"
                                        autocomplete="off" type="text" mask="separator"
                                        [ngModelOptions]="{standalone: true}" />
                                </td>
                                <td>
                                    <input (input)="onInputChange($event)" [disabled]="item.codification =='A'"
                                        [class.isNotConsidered]="item.nombre_autorise == 0"
                                        class="form-control custom-input"
                                        [(ngModel)]="item.surprime_si_supplementaire"
                                        autocomplete="off" type="text" mask="separator"
                                        [ngModelOptions]="{standalone: true}" />
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
        
    </div>

    
    <div class="col col-md-4">
        <div class="row">

            <div class="col col-md-3">
                <label>Age min :
                    <!-- <span class="required_champs">*</span> -->
                </label>
                <input class="form-control custom-input" placeholder="Age min" autocomplete="off"
                    [(ngModel)]="itemToAddTrancheAge.age_min" name="age_min" autocomplete="off" mask="separator"
                    type="text" />
            </div>
            <div class="col col-md-3">
                <label>Age max
                    <!-- <span class="required_champs">*</span> -->
                </label>
                <input (input)="onInputChange($event)" class="form-control custom-input" placeholder="Age max" autocomplete="off"
                    [(ngModel)]="itemToAddTrancheAge.age_max" name="age_max" autocomplete="off"
                    type="text" mask="separator">
            </div>
            <div class="col col-md-4">
                <label>Prime
                    <!-- <span class="required_champs">*</span> -->
                </label>
                <input (input)="onInputChange($event)"  class="form-control custom-input" placeholder="Prime" autocomplete="off"
                    [(ngModel)]="itemToAddTrancheAge.prime" name="prime" autocomplete="off" type="text"
                    mask="separator" />
            </div>
            <div class="col col-md-1" style="text-align: right;">
                <br>
                <button class="btn btn-info" (click)="onAddItemToTableTrancheAge();"><i
                        class="fa fa-plus"></i></button>
            </div>
        
        
            <div class="table-responsive" style="min-height:210px;overflow:auto;">
                <table class="table table-stripped table-bordered table-hover">
                    <thead>
                        <tr class="custom-table-head">
                            <th> <a style="cursor: pointer;margin-top: 5px;" (click)="refreshList()"
                                title="Actualiser">
                                <i class="fa fa-redo-alt"></i></a>
                            </th>
                          
                            <th>Age min</th>
                            <th>Age max</th>
                            <th>Prime</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let item of itemsPrimeByTrancheAge; let indice = index"
                            style="cursor: pointer;">
                            <td>{{indice+1}}</td>
                            <td>{{item.age_min}}</td>
                            <td>{{item.age_max}}</td>
                            <td>{{item.prime | mask:'separator'}}</td>
                            <td><i style="color: red;" class="fa fa-trash"
                                    (click)="itemsPrimeByTrancheAge.splice(indice,1)"></i></td>
                        </tr>
                    </tbody>
                </table>
            </div>
            
        </div>
    </div>


</div>

